'use client';

import React, { useState } from 'react';
import FeedbackForm from './FeedbackForm';
import SuccessMessage from './SuccessMessage';
import FeedbackStats from './FeedbackStats';

interface FeedbackFormData {
  coachingQuality: number;
  platformUsability: number;
  overallSatisfaction: number;
  coachingEffectiveness: string;
  featureRequests: string;
  improvementSuggestions: string;
  feedbackCategory: string;
  coachingRelevance: string;
  investorReadinessAccuracy: string;
  platformNavigation: string;
  contactName: string;
  contactEmail: string;
  allowFollowUp: boolean;
  isAnonymous: boolean;
}

const FeedbackCollectionInteractive = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [submitError, setSubmitError] = useState('');

  const handleSubmit = async (data: FeedbackFormData) => {
    setIsSubmitting(true);
    setSubmitError('');

    try {
      const response = await fetch('/api/feedback', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          source: 'feedback-collection',
          ...data,
        }),
      });

      const payload = await response.json().catch(() => null);

      if (!response.ok) {
        throw new Error(payload?.error?.message || 'No pudimos enviar tu feedback en este momento.');
      }

      setShowSuccess(true);
    } catch (error) {
      const message = error instanceof Error ? error.message : 'No pudimos enviar tu feedback en este momento.';
      console.error('Error submitting feedback:', error);
      setSubmitError(message);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCloseSuccess = () => {
    setShowSuccess(false);
  };

  return (
    <>
      <div className="space-y-8">
        <FeedbackStats />
        {submitError && (
          <div className="bg-red-50 border border-red-200 text-red-700 rounded-lg p-4">
            {submitError}
          </div>
        )}
        <FeedbackForm onSubmit={handleSubmit} isSubmitting={isSubmitting} />
      </div>

      {showSuccess && <SuccessMessage onClose={handleCloseSuccess} />}
    </>
  );
};

export default FeedbackCollectionInteractive;
